
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';

const TimeLineEntity = ({ item }) => {
    const { push } = useHistory(); 
    const editChange = () => {
        push("Timeline/changeCharter/" + item.entityId);
    }
    return item && item.entity === 'ChangeCharter' ? <Button onClick={editChange}>Change Charter</Button> : item ? item.entity : '';
}

export default TimeLineEntity; 